import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import text from "../styles/typography.module.scss"
import ContactForm from "../components/contactForm"
import Getstarted from "../components/GetStarted"
import Subhero from "../components/subhero"
import IconLink from "../components/IconLink"
import "../styles/contact.scss"

export default () => (
  <Layout>
    <SEO 
      title={"Contact us"} 
      description={"MinutScript is a new and modern video communication enterprise, with an easy and accountable plugin for your video and chat conferencing platform, both on mobile and desktop devices. MinutScript is a new way of connecting people across the world, giving easy access to planning and executing your future meetings. With an installed speech-to-text converter, it is easy to edit and share your meeting minutes with MinutScript. Founded in 2020 and headquarters in Zealand, Denmark."}
    />
    <Subhero>
      <h1 className={text.heading1}>Get in touch </h1>
    </Subhero>
    <section class="contact">
      <div class="layout">
        <div class="form">
          <h2 className={text.heading2}>
            Want to know how MinutScript<br></br>can make your companys meetings
            <br></br>more efficient?
          </h2>
          <p className={text.paragraph}>
            Fill out the form below and we will be in touch as fast as possible.
            Need technical support?
          </p>
          <p className={text.paragraph}>
            E-mail us at
            <a href="mailto:support@minutscript.com">
              {" "}
              support@minutscript.com
            </a>
          </p>
          <ContactForm />
        </div>
        <div class="socials">
          <div class="aside">
            <h2 className={text.heading2}>Contact us</h2>
            <IconLink
              dark={true}
              icon={"mail"}
              href={"mailto:hello@minutscript.com"}
              text={"hello@minutscript.com"}
            />
            <IconLink
              dark={true}
              icon={"phone"}
              href={""}
              text={"+45 11 22 33 44"}
            />
          </div>
          <div class="aside">
            <h2 className={text.heading2}>Where to find MinutScript</h2>
            <IconLink
              dark={true}
              href="https://facebook.com"
              icon="facebook"
              text="minutscript"
            />
            <IconLink
              dark={true}
              href="https://linkedin.com"
              icon="linkedin"
              text="minutscript"
            />
            <IconLink
              dark={true}
              href="https://twitter.com"
              icon="twitter"
              text="@minutscript"
            />
          </div>
        </div>
      </div>
    </section>

    <Getstarted primary={true} />
  </Layout>
)
